import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/globals.css';
import './styles/marquee.css';
import reportWebVitals from './reportWebVitals';
import { resolveMaintenanceMode } from './utils/resolveMaintenanceMode';

async function bootstrap() {
  const root = ReactDOM.createRoot(document.getElementById('root'));

  try {
    const maintenance = await resolveMaintenanceMode();

    if (maintenance) {
      const { default: MaintenancePage } = await import('./pages/MaintenancePage');
      root.render(
        <StrictMode>
          <MaintenancePage />
        </StrictMode>,
      );
    } else {
      const { default: App } = await import('./App');
      root.render(
        <StrictMode>
          <App />
        </StrictMode>,
      );
    }
  } catch {
    const { default: App } = await import('./App');
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  }

  reportWebVitals();
}

bootstrap();
